let $ = jQuery;

module.exports = {
  attach: function (context, settings) {

    if (context !== document) {
      return;
    }

    // Ajax paging of blocks in Dashboard.
    $(context).on('click', ".pager__anchor", function() {
      var el = $(this).closest('.dashboard__cards');

      var url = $(this).attr('href');

      if (!url) {
        return;
      }

      Drupal.ajax({
        url: Drupal.url(url.substr(1)),
        error: function () {
          $(el).find('.error').remove();
          $(el).prepend('<p class="error">There was an ajax error.</p>');
        }
      }).execute();

      return false;
    });

  }
};
